import React, { useEffect, useState } from "react";

// Top scroll-progress bar — sticks to the very top of the viewport (above header),
// fills with brand-orange as the user scrolls. Pure CSS transform for 60fps.
export const ScrollProgress = () => {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      const p = max > 0 ? (h.scrollTop / max) * 100 : 0;
      setPct(p);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <div
      data-testid="scroll-progress"
      aria-hidden
      className="fixed top-0 left-0 right-0 z-[60] h-[2px] pointer-events-none"
    >
      <div
        className="h-full bg-gradient-to-r from-brand-orange via-orange-400 to-brand-orange shadow-[0_0_12px_rgba(255,106,0,0.6)] transition-transform duration-150 origin-left"
        style={{ transform: `scaleX(${pct / 100})`, width: "100%" }}
      />
    </div>
  );
};
